// Utils
import moment from "moment";
import { formatDatetime } from "react-lib/utils/dateUtils";
import { HeaderLogoWithPublishDetail } from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";
import { TDocumentDefinitions } from "pdfmake/interfaces";

const FORM_NAME = `FormAnesMethodCaseStatReport`;

const FormAnesMethodCaseStatReport = async (props: any): Promise<TDocumentDefinitions> => {
  // console.log("Yeti Anes Method & Case Props: ", props);

  const currentDate = moment();

  const headerForm = await HeaderLogoWithPublishDetail({
    form: FORM_NAME,
    font: "THSarabunNew",
    logoHeight: 30,
    isHospitalVertical: true,
    haveBorder: true,
    pageMargins: [10, 85, 10, 10],
    headerMargins: [10, 10, 10, 0],
    titleContent: [
      {
        text: `จำนวนผู้รับบริการระงับความรู้สึก แบ่งตามวิธีระงับความรู้สึก และประเภทเคส`,
        alignment: "center",
        fontSize: 15,
        bold: true,
      },
      {
        text: `วิธีระงับความรู้สึก ${props.params?.anesthesia_label || "ทั้งหมด"}`,
        alignment: "center",
        fontSize: 15,
      },
      {
        text: `วันที่ดมยา ${props.params?.startDate || " "} - ${props.params?.endDate || " "}`,
        alignment: "center",
        fontSize: 15,
      },
    ],
    publishContent: [
      {
        text: [
          { text: "ผู้พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: props.params?.print_user || " " },
        ],
        fontSize: 12,
        alignment: "right",
      },
      {
        text: [
          { text: "วันที่พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: formatDatetime(currentDate, true) },
        ],
        fontSize: 12,
        alignment: "right",
      },
    ],
  });

  const { font, images, styles } = headerForm;

  const generateTableBody = (data: any, columns: string[]) => {
    let body: any = [];

    // Header of Table
    body.push([
      { text: "วิธีระงับความรู้สึก", bold: true, alignment: "center" },
      { text: "ในเวลา", bold: true, alignment: "center" },
      { text: "นอกเวลา", bold: true, alignment: "center" },
      { text: "รวมเคสทั้งหมด", bold: true, alignment: "center" },
    ]);

    if (Object.keys(data).length > 0) {
      const fieldsData = data?.items;
      const summaryData = data?.summaryTotals;

      fieldsData.forEach((row: any) => {
        let dataRow: any = [];

        columns.forEach((column: any) => {
          switch (column) {
            case "is_opd":
            case "is_ipd":
            case "is_hid":
              dataRow.push({ text: row[column], alignment: "center" });
              break;
            default:
              dataRow.push({ text: row[column].toString(), bold: true });
              break;
          }
        });
        body.push(dataRow);
      });

      // Total Row
      if (summaryData) {
        body.push([
          {
            text: "จำนวนผู้รับบริการรวม",
            fillColor: "#cccccc",
            border: [true, true, false, true],
          },
          {
            text: `ในเวลา ${summaryData.total_male}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, false, true],
          },
          {
            text: `นอกเวลา ${summaryData.total_female}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, false, true],
          },
          {
            text: `เท่ากับ ${summaryData.total_all}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, true, true],
          },
        ]);
      }
    }

    return body;
  };

  const tableReport = (data: any, columns: string[]) => {
    return {
      table: {
        widths: ["*", "15%", "15%", "15%"],
        headerRows: 1,
        body: generateTableBody(data, columns),
      },
    };
  };

  return {
    pageSize: "A4",
    pageOrientation: "landscape",
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 16, // default
    },
    ...headerForm,
    styles: { ...styles },
    images: { ...images },
    content: [tableReport(props || {}, ["anesthesia_name", "is_opd", "is_ipd", "is_hid"])],
  };
};

export default FormAnesMethodCaseStatReport;
